import * as React from 'react';

function SvgAccount(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} {...props}>
      <defs>
        <clipPath id="account_svg__clip-path">
          <path
            id="account_svg__Rectangle_371"
            d="M0 0h24v24H0z"
            className="account_svg__cls-1"
            data-name="Rectangle 371"
            transform="translate(126 624)"
          />
        </clipPath>
        <style>{`.account_svg__cls-1{fill:${props.fill}}`}</style>
      </defs>
      <g
        id="account_svg__account"
        transform="translate(-126 -624)"
        clipPath="url(#account_svg__clip-path)"
      >
        <g
          id="account_svg__Group_224"
          data-name="Group 224"
          transform="translate(-102.726 555.074)"
        >
          <path
            id="account_svg__Path_262"
            d="M240.869 91.137a10.07 10.07 0 117.119-2.949.654.654 0 01-.924-.924 8.74 8.74 0 10-1.8 1.383.654.654 0 01.658 1.13 10.063 10.063 0 01-5.053 1.36z"
            className="account_svg__cls-1"
            data-name="Path 262"
          />
          <path
            id="account_svg__Path_263"
            d="M247.531 93.1h-7.28a.65.65 0 010-1.3h7.28a.65.65 0 010 1.3z"
            className="account_svg__cls-1"
            data-name="Path 263"
            transform="translate(-3.022 -7.195)"
          />
          <path
            id="account_svg__Path_264"
            d="M240.125 85.15a1.625 1.625 0 111.625-1.625 1.626 1.626 0 01-1.625 1.625zm0-2.6a.975.975 0 10.975.975.976.976 0 00-.975-.975z"
            className="account_svg__cls-1"
            data-name="Path 264"
            transform="translate(-2.66 -3.765)"
          />
          <path
            id="account_svg__Path_265"
            d="M250.525 85.15a1.625 1.625 0 111.625-1.625 1.626 1.626 0 01-1.625 1.625zm0-2.6a.975.975 0 10.975.975.976.976 0 00-.975-.975z"
            className="account_svg__cls-1"
            data-name="Path 265"
            transform="translate(-6.253 -3.765)"
          />
        </g>
      </g>
    </svg>
  );
}

export default SvgAccount;
